import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
    mutation updateUser($id: ID!, $userInput: UserInput!){
        updateUser(id: $id, userInput: $userInput) {
            _id
        }
    }
`;
